import {
  enumListAsRecordObject,
  lookupListAsRecordObject
} from '@utils/graph-utils';

export function toLookups(data: any) {
  const personDetailsList: Record<string, Record<string, string>> = {};

  personDetailsList['personType'] = enumListAsRecordObject(
    data?.PersonType?.enumValues
  );

  personDetailsList['phoneType'] = enumListAsRecordObject(
    data?.PhoneType?.enumValues
  );

  personDetailsList['genders'] = enumListAsRecordObject(
    data?.Gender?.enumValues
  );

  personDetailsList['maritalStatuses'] = enumListAsRecordObject(
    data?.MaritalStatus?.enumValues
  );

  personDetailsList['titles'] = lookupListAsRecordObject(data?.core?.getTitles);

  personDetailsList['countries'] = lookupListAsRecordObject(
    data?.core?.getCountries
  );

  personDetailsList['nationalities'] = lookupListAsRecordObject(
    data?.core?.getNationalities,
    false,
    'id',
    'title',
    'code',
    true
  );

  personDetailsList['occupationClass'] = lookupListAsRecordObject(
    data?.core?.getOccupationClass
  );

  // Profession dropdown: keyed by occupation id, label "Description Arabic".
  personDetailsList['occupationList'] = toOccupationListOptions(
    data?.core?.getOccupationList
  );

  personDetailsList['activePersons'] = lookupListAsRecordObject(
    data?.salesforce?.getAllPersons,
    false,
    'id',
    'fullName',
    'code'
  );

  personDetailsList['personRelation'] = enumListAsRecordObject(
    data?.PersonRelation?.enumValues,
    false,
    true
  );

  return personDetailsList;
}

// Builds the Profession dropdown options from getOccupationList:
// key = occupation id, label = "Description Arabic".
export function toOccupationListOptions(
  occupationList: any[] | undefined | null
): Record<string, string> {
  const options: Record<string, string> = {};
  if (!Array.isArray(occupationList)) return options;

  occupationList.forEach((occupation) => {
    const id = occupation?.id;
    if (!id) return;

    const description = occupation?.description ?? '';
    const arabic = occupation?.arabic ?? '';
    options[id] = [description, arabic].filter(Boolean).join(' ').trim();
  });

  return options;
}

// Maps each occupation id to its occupation class id, used to auto-derive the
// read-only Occupation Class field from the selected Profession.
export function toOccupationClassMap(
  occupationList: any[] | undefined | null
): Record<string, string> {
  const map: Record<string, string> = {};
  if (!Array.isArray(occupationList)) return map;

  occupationList.forEach((occupation) => {
    const id = occupation?.id;
    const classId =
      occupation?.occupationClassId ?? occupation?.occupationClass?.id;
    if (id && classId != null) {
      map[id] = String(classId);
    }
  });

  return map;
}

export const filterPersonLovsById = (
  lovs: Record<string, string> | undefined | null,
  idToRemove: string
): Record<string, string> => {
  if (!lovs) return {};

  const updatedLovs: Record<string, string> = {};

  Object.entries(lovs).forEach(([id, label]) => {
    if (id !== idToRemove) {
      updatedLovs[id] = label;
    }
  });

  return updatedLovs;
};
